import { create } from "zustand";
import { persist } from "zustand/middleware";
import { runsOnDevice } from "../api/client.js";

/**
 * How Home looks, where the choice costs performance.
 *
 * The banner trailer is the one setting here so far: the featured title's
 * trailer playing behind the banner looks good, but on the 1 GB projector the
 * YouTube player starved the page — a remote press took seven seconds, and
 * after a few hero rotations the app stopped answering (2026-09-20). So the APK
 * starts with it off and offers it to devices that can take it; a browser,
 * where it was never a problem, keeps it on.
 */
/** 12 keeps a TV's rails light; 24 is the longer row. */
export type TilesPerRow = 12 | 24;

interface AppearanceState {
  heroTrailer: boolean;
  /** The "Live Now" row: its schedule is fetched and matched against every channel. */
  liveNowRow: boolean;
  /** The banner changing to another featured title every minute. */
  heroRotation: boolean;
  tilesPerRow: TilesPerRow;
  setHeroTrailer: (on: boolean) => void;
  setLiveNowRow: (on: boolean) => void;
  setHeroRotation: (on: boolean) => void;
  setTilesPerRow: (count: TilesPerRow) => void;
}

export const useAppearance = create<AppearanceState>()(
  persist(
    (set) => ({
      heroTrailer: !runsOnDevice(),
      liveNowRow: true,
      heroRotation: true,
      tilesPerRow: 12,
      setHeroTrailer: (heroTrailer) => set({ heroTrailer }),
      setLiveNowRow: (liveNowRow) => set({ liveNowRow }),
      setHeroRotation: (heroRotation) => set({ heroRotation }),
      setTilesPerRow: (tilesPerRow) => set({ tilesPerRow }),
    }),
    {
      name: "slique-appearance",
      version: 2,
    },
  ),
);
